var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("b-row", [_c("b-col", { staticClass: "text-right" })], 1),
      _vm._v(" "),
      _c("b-table", {
        staticClass: "text-nowrap mt-3",
        attrs: {
          responsive: "",
          borderless: "",
          "show-empty": "",
          small: "",
          "current-page": _vm.currentPage,
          "sort-direction": "asc",
          "per-page": _vm.perPage,
          items: _vm.items,
          fields: _vm.fields,
          "thead-class": "custom-header",
        },
        scopedSlots: _vm._u([
          {
            key: "head()",
            fn: function (data) {
              return [
                _c("div", { staticClass: "text-center" }, [
                  _vm._v("\n        " + _vm._s(data.label) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "empty",
            fn: function () {
              return [
                _c("div", { staticClass: "text-center h3 mt-3" }, [
                  _vm._v(
                    _vm._s(_vm.$t("apeironGwApp.persona.expediente.empty"))
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "cell()",
            fn: function (data) {
              return [
                typeof data.value == "boolean"
                  ? _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        data.value
                          ? _c("b-icon", {
                              staticClass: "i-selected",
                              attrs: {
                                icon: "check-square",
                                variant: "primary",
                                "font-scale": "1.2",
                              },
                            })
                          : _c("b-icon", {
                              staticClass: "i-selected",
                              attrs: {
                                icon: "square",
                                variant: "primary",
                                "font-scale": "1.2",
                              },
                            }),
                      ],
                      1
                    )
                  : data.field.link
                  ? _c(
                      "div",
                      [
                        data.value
                          ? _c(
                              "b-link",
                              { attrs: { target: "_blank", href: data.value } },
                              [_vm._v("Ver convenio")]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : data.field.linkComprobante
                  ? _c(
                      "div",
                      [
                        data.value
                          ? _c(
                              "b-link",
                              { attrs: { target: "_blank", href: data.value } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("documentos.verComprobante"))
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : data.field.key == "urlReconocimiento"
                  ? _c(
                      "div",
                      [
                        data.value
                          ? _c(
                              "b-link",
                              { attrs: { target: "_blank", href: data.value } },
                              [_vm._v("Ver reconocimiento")]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "text-center" }, [
                      _vm._v("\n        " + _vm._s(data.value) + "\n      "),
                    ]),
              ]
            },
          },
          {
            key: "cell(accion)",
            fn: function () {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.noTieneAdeudo,
                            expression: "noTieneAdeudo",
                          },
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.right",
                            value: _vm.$t("Ver constancia"),
                            expression: "$t('Ver constancia')",
                            modifiers: { hover: true, right: true },
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.generarPdfConstanciaNoAdeudos()
                          },
                        },
                      },
                      [_c("b-icon-file-earmark-pdf-fill")],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("b-pagination", {
        attrs: {
          "total-rows": _vm.totalRows,
          "per-page": _vm.perPage,
          align: "center",
          size: "sm",
          pills: "",
        },
        model: {
          value: _vm.currentPage,
          callback: function ($$v) {
            _vm.currentPage = $$v
          },
          expression: "currentPage",
        },
      }),
      _vm._v(" "),
      _c("visualizador-pdf", {
        attrs: {
          id: "visualizador-pdf",
          contenidoBase64: _vm.contenidoBase64,
          mostrar: _vm.pdfReady,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }